import React, { Component } from 'react'
import { capitalize } from 'lodash'

const withKeyValue = (options = {}) => (WrappedComponent) => {
  return class extends Component {
    render() {
      const { data } = this.props
      const keyValueData = data.map((c) => ({
        key: c,
        value: options.capitalize ? capitalize(c) : c,
      }))
      return <WrappedComponent {...this.props} data={keyValueData} />
    }
  }
}

export default withKeyValue
